module.exports = __webpack_public_path__ + "img/home_bg0_pre.fea30cf6.png";